<template>
  <div class="overflow-hidden rounded-xl">
    <table class="w-full">
      <thead class="bg-gradient-to-r from-slate-900/95 to-slate-800/95 dark:from-slate-900/95 dark:to-slate-800/95 backdrop-blur-md border-b border-slate-700/50 dark:border-slate-700/50">
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
            class="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y dark:divide-gray-700/50 bg-white/80 dark:bg-slate-900/60">
        <tr
          v-for="item in items"
          :key="item[itemKey]"
          class="hover:bg-gray-800/30 transition-colors"
        >
          <td
            v-for="column in columns"
            :key="column.key"
            class="px-6 py-4"
            :class="column.key === 'actions' ? '' : 'whitespace-nowrap'"
          >
            <slot
              :name="column.key"
              :value="item[column.key]"
              :item="item"
            >
              <span
                v-if="column.key === 'mac_address'"
                class="text-fuchsia-600 dark:text-cyan-400 font-mono text-sm"
              >
                {{ item[column.key] }}
              </span>
              <span v-else class="text-gray-200">
                {{ item[column.key] }}
              </span>
            </slot>
          </td>
        </tr>
        <tr v-if="items.length === 0">
          <td
            :colspan="columns.length"
            class="px-6 py-8 text-center text-gray-400"
          >
            {{ emptyMessage }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
defineProps({
  columns: {
    type: Array,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  itemKey: {
    type: String,
    default: 'id',
  },
  emptyMessage: {
    type: String,
    default: 'No data available.',
  },
});
</script>

<style scoped>

</style>